import { FocusEvent, Status } from 'features/Marketing/types';
import { TFunction } from 'react-i18next';

export const getLabels = (
	emailsSent: number,
	focus: FocusEvent[],
	status: Status,
	t: TFunction<'translation', undefined>
) => [
	{ extraWidth: true, label: 'emails', data: emailsSent },
	{ extraWidth: true, label: 'focus', data: focus[0]?.name },
	{
		extraWidth: false,
		label: 'status',
		data: t(`marketing-campaignInfo-${status}`),
	},
];
